import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// PLUGINS
import vuetify from "./plugins/vuetify";
import firebaseMessaging from "./plugins/firebase";
import "./plugins/snotify";
import "./plugins/vee-validate";
import "./plugins/apex-chart";
import "./plugins/sweetAlert";
import "./plugins/third-parties/vue-datime-picker";

// filtros
import filters from "./filters";
Vue.use(filters);

Vue.config.productionTip = false;
store.dispatch("passport/TRY_AUTO_LOGIN");

Vue.prototype.$messaging = firebaseMessaging;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
